<template>
  <DxDrawer opened-state-mode="push" position="right" reveal-mode="expand" v-model:opened="drawerOpen"
    :close-on-outside-click="false" template="request">

    <template #request>
      <div style="width: 560px">
        <ContainerRequestForm :key="selectedRequest" :container="container" :selected-request="selectedRequest"
          @request-submitted="handleRequestSubmitted" @request-cancelled="closeRequest" />
      </div>
    </template>

    <hr />
    <div>
      <DxBox>
        <DxItem :ratio="1">
          <DxButton class="requestBtn" text="Request Calibration" @click="openRequest('calibration')" />
        </DxItem>
        <DxItem :ratio="1">
          Request a sensor calibration comparing data from a physical measurement with calculated properties.
        </DxItem>
      </DxBox>
      <hr />
      <DxBox>
        <DxItem :ratio="1">
          <DxButton class="requestBtn" text="Change Product" @click="openRequest('product')" />
        </DxItem>
        <DxItem :ratio="1">
          Request a product/chemical change.
        </DxItem>
      </DxBox>
      <hr />
      <DxBox>
        <DxItem :ratio="1">
          <DxButton class="requestBtn" text="Change Tank" @click="openRequest('tank')" />
        </DxItem>
        <DxItem :ratio="1">
          Request a tank change (Size/Shape/Capacity).
        </DxItem>
      </DxBox>
      <hr />
      <!-- <DxBox> -->
      <!-- <DxItem :ratio="1"> -->
      <!-- <DxButton class="requestBtn" text="Change Location" @click="openRequest('location')" /> -->
      <!-- </DxItem> -->
      <!-- <DxItem :ratio="1"> -->
      <!-- Request a location change. -->
      <!-- </DxItem> -->
      <!-- </DxBox> -->
      <!-- <hr/> -->
    </div>
  </DxDrawer>
</template>

<script>

import DxButton from 'devextreme-vue/button';
import { DxBox, DxItem } from 'devextreme-vue/box';
import DxDrawer from 'devextreme-vue/drawer';
import ContainerRequestForm from './container-request-form.vue';

export default {
  components: {
    DxButton,
    DxBox,
    DxItem,
    DxDrawer,
    ContainerRequestForm,
  },
  props: ['containerId', 'container'],
  created() {
    this.loadPageData()
  },
  data() {
    return {
      selectedRequest: "",
      drawerOpen: false,
    };
  },
  methods: {
    loadPageData() {
    },
    openRequest(req) {
      this.selectedRequest = req;
      this.drawerOpen = !this.drawerOpen;
    },
    closeRequest() {
      this.drawerOpen = !this.drawerOpen;
    },
    handleRequestSubmitted(request) {
      this.$store.dispatch('containers/sendActionRequest', request);
      this.$emit('recordUpdated');
      this.closeRequest();
    },
  },
};

</script>

<style scoped>
.divGroup {
  width: 90%;
  border-style: solid;
  border-width: 1px;
  margin: 20px;
  border-color: rgb(100, 100, 100);
  border-radius: 6px;
  padding: 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.requestBtn {
  /* color: rgb(65, 65, 65);   */
  color: black;
  background-color: rgb(255, 115, 0);
  margin: 0 20px 20px 0;
  /* border-color: rgb(100, 100, 100);
    border-radius: 6px; */
  /* padding: 20px; */
}

.requestBtn.dx-state-hover {
  /* color: black;   */
  background-color: rgb(223, 102, 4);
}

hr {
  height: 1px;
  border: 1px solid #444;
}
</style>
